import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Layout from '../../pages/_layouts/default';

import { useDispatch, useSelector } from 'react-redux';
import { updateProfileRequest } from '../../store/modules/user/actions'

import Input from '../../components/Input';
import Button from '../../components/Button';
import Title from '../../components/Title';
import Small from '../../components/Small';
import * as S from './styled';


const Profile = () => {

  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);
  const profile = useSelector(state => state.user.profile);
  
  const [oldPass, setOldPass] = useState("");
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  
  const [borderOldPass, setBorderOldPass] = useState("#FDCB00");
  const [borderPass, setBorderPass] = useState("#FDCB00");
  const [borderConfirmPass, setBorderConfirmPass] = useState("#FDCB00");

  function validationInput(e, inputType) {
    const inputLength = e.length;

    if (inputLength >= 1 && inputLength < 6) {
      if (inputType === 'oldPass') {
        setBorderOldPass('red');
      } else if (inputType === 'pass') {
        setBorderPass('red');
      } else if (inputType === 'confirmPass') {
        setBorderConfirmPass('red');
      }
    } else {
      if (inputType === 'oldPass') {
        setBorderOldPass('green');
      } else if (inputType === 'pass') {
        setBorderPass('green');
      } else if (inputType === 'confirmPass') {
        setBorderConfirmPass('green');
      }
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    if(!oldPass) {
      toast.error('Necessário preenchimento da senha anterior!');
      return;
    }

    if(!pass) {
      toast.error('Necessário preenchimento da nova senha!');
      return;
    }
    
    if(!confirmPass) {
      toast.error('Necessário preenchimento da confirmação de senha!');
      return;
    }

    if(borderOldPass === 'red' || borderPass === 'red' || borderConfirmPass === 'red') {
      toast.error('Ops, campos podem não estar preenchidos corretamente! Verifique seus dados.'); 
      return;
    }

    const data = { oldPassword: oldPass, password: pass, confirmPassword: confirmPass };

    dispatch(updateProfileRequest(data));

    setOldPass("");
    setPass("");
    setConfirmPass("");
    
    setBorderOldPass('#FDCB00');
    setBorderPass('#FDCB00');
    setBorderConfirmPass('#FDCB00');
  }
    
  return (
    <Layout>
      <>
        <Title text="Meu perfil" />
        <S.FormWrapper>
          <S.Form  onSubmit={ handleSubmit }>
            <Input 
              type="text"
              placeholder="Digite o seu nome"
              label="Nome"
              value={ profile.name }
              disabled
            />
            <Input 
              type="text" 
              placeholder="000.000.000-00"
              mask="999.999.999-99" 
              label="Cpf"
              value={ profile.cpf }
              disabled
            />

              <Input 
                type="password" 
                placeholder="••••••••"
                label="Senha anterior"
                value={ oldPass }
                method={ e => {
                  setOldPass(e.target.value);
                  validationInput(e.target.value, 'oldPass');
                }}
                border={ borderOldPass }
                />
              <Input 
                type="password" 
                placeholder="••••••••"
                label="Nova senha"
                value={ pass }
                method={ e => {
                  setPass(e.target.value);
                  validationInput(e.target.value, 'pass');
                }}
                border={ borderPass }
                />
              <Input 
                type="password" 
                placeholder="••••••••"
                label="Confirmar senha"
                value={ confirmPass }
                method={ e => {
                  setConfirmPass(e.target.value);
                  validationInput(e.target.value, 'confirmPass');
                }}
                border={ borderConfirmPass }
                />
            <S.ControlsWrapper>
              <Small to="/dashboard">Voltar</Small>
              <Button type="submit" text={ loading ? 'Carregando...' : 'Alterar' } background="#0B4683"/>
            </S.ControlsWrapper>
          </S.Form>
        </S.FormWrapper>
      </>
    </Layout>
  );
}

export default Profile;